export const buildPathWithSearchParams = (
  pathname: string,
  searchParams: URLSearchParams,
): string => {
  const queryString = searchParams.toString();

  return queryString ? `${pathname}?${queryString}` : pathname;
};

/**
 * Strips processed query params from the URL without triggering a Next.js
 * soft navigation. Dispatching `popstate` tells the App Router to re-sync
 * its internal state from `window.location`, so `useSearchParams` updates.
 *
 * Note: `window.history.state` will still reference the old query params after this call.
 * This is ok because the App Router re-derives `useSearchParams` from
 * `window.location` on `popstate`, not from the history state object.
 * If a future Next.js version changes this, we may need to patch the state object too.
 */
export const replaceCurrentUrl = (url: string): void => {
  window.history.replaceState(window.history.state, "", url);
  window.dispatchEvent(new PopStateEvent("popstate", { state: window.history.state }));
};
